// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".del-button {\n  position: relative;\n  left: -0.5rem;\n}\n.field-dropdown-width-fix {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  width: 1% !important;\n}\n", ""]);
// Exports
module.exports = exports;
